<template>
  <div class="test-register-cards-component ">
    <div class="row">
      <div class="col-12 col-lg-4 mb-4" v-for="component in components">
        <div class="card-box">
          <div class="card-box-welcome login-card">
            <div :is="component" :form="form"></div>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-4 mb-4">
        <div class="card-box">
          <div class="card-box-welcome login-card">
            <RegistrationSuccessCard :form="form" timeout="-1"></RegistrationSuccessCard>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import { mapGetters } from 'vuex';

import WelcomeCard from '../Auth/WelcomeCard';
import RegisterEmailCard from '../Auth/RegisterEmailCard';
import RegisterPhoneCard from '../Auth/RegisterPhoneCard';
import VerificationPhoneCard from '../Auth/VerificationPhoneCard';
import VerificationEmailCard from '../Auth/VerificationEmailCard';
import LoginCard from '../Auth/LoginCard';
import NameCard from '../Auth/NameCard';
import GenderCard from '../Auth/GenderCard';
import BirthdayCard from '../Auth/BirthdayCard';
import LocationCard from '../Auth/LocationCard';
import RegistrationSuccessCard from '../Auth/RegistrationSuccessCard';
import ResetPasswordCard from '../Auth/ResetPasswordCard';
import ResetPasswordEmailCard from '../Auth/ResetPasswordEmailCard';
import ResetPasswordPhoneCodeCard from '../Auth/ResetPasswordPhoneCodeCard';
import ResetPasswordPhoneCard from '../Auth/ResetPasswordPhoneCard';

export default {
  components: { RegistrationSuccessCard },
  data() {
    return {
      form: {},
      components: {
        'auth-welcome-card': WelcomeCard,
        'auth-register-email-card': RegisterEmailCard,
        'auth-register-phone-card': RegisterPhoneCard,
        'auth-verification-phone-card': VerificationPhoneCard,
        'auth-verification-email-card': VerificationEmailCard,
        'auth-login-card': LoginCard,
        'auth-name-card': NameCard,
        'auth-gender-card': GenderCard,
        'auth-birthday-card': BirthdayCard,
        'auth-location-card': LocationCard,
        'auth-reset-password-card': ResetPasswordCard,
        'auth-reset-password-email-card': ResetPasswordEmailCard,
        'auth-reset-password-phone-code-card': ResetPasswordPhoneCodeCard,
        'auth-reset-password-phone-card': ResetPasswordPhoneCard,
        //      'auth-registration-success-card': RegistrationSuccessCard,
      }

    };
  },
  computed: {
    ...mapGetters('user', {
      user: 'getUser',
    }),
  },
  methods: {},
  mounted() {

  }
};
</script>
